import { clsx } from 'clsx';
import { savingsColor } from './dashboardHelpers';

const SavingsRing = ({ rate, size = 88 }) => {
  const r = (size - 10) / 2;
  const circ = 2 * Math.PI * r;
  const clampedRate = Math.min(100, Math.max(-100, rate));
  const filled = (Math.max(0, clampedRate) / 100) * circ;
  const { text, ring, label } = savingsColor(rate);
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90" style={{ overflow: 'visible' }}>
          <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="currentColor"
            className="text-gray-200 dark:text-gray-700" strokeWidth={9} />
          <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={ring} strokeWidth={9}
            strokeDasharray={circ} strokeDashoffset={circ - filled} strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 0.6s ease' }} />
        </svg>
        <div className="absolute flex flex-col items-center">
          <span className={clsx('text-xl font-bold leading-none', text)}>
            {clampedRate > 0 ? '+' : ''}{clampedRate.toFixed(0)}%
          </span>
        </div>
      </div>
      <span className={clsx('text-xs font-semibold', text)}>{label}</span>
    </div>
  );
};

export default SavingsRing;
